import EvalEvaluatorTable from './src/main';

/* istanbul ignore next */
EvalEvaluatorTable.install = function(Vue) {
  Vue.component(EvalEvaluatorTable.name, EvalEvaluatorTable);
};

export default EvalEvaluatorTable;
